import { useMemo, useRef } from 'react';
import { CodeEntryContext } from './context';
import { useStore } from '@/store';
import { CodeEntryStore, createCodeEntryStore } from '../../store';
import { useNavigate } from 'react-router';

interface CodeEntryProviderProps extends React.PropsWithChildren {
  id: string;
}

export const CodeEntryProvider = ({ children, id }: CodeEntryProviderProps) => {
  const navigate = useNavigate();

  const globalStore = useStore();
  const storeRef = useRef<CodeEntryStore>();

  storeRef.current = useMemo(() => {
    return createCodeEntryStore(globalStore, {
      id,
      navigate,
    });
  }, [globalStore, id]);

  return (
    <CodeEntryContext.Provider value={storeRef.current}>
      {children}
    </CodeEntryContext.Provider>
  );
};
